var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIconDot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 4.5C6.33579 4.5 6 4.83579 6 5.25V18.75C6 19.1642 6.33579 19.5 6.75 19.5H17.25C17.6642 19.5 18 19.1642 18 18.75V8.12132C18 7.92241 17.921 7.73164 17.7803 7.59099L14.909 4.71967C14.7684 4.57902 14.5776 4.5 14.3787 4.5H6.75ZM4.5 5.25C4.5 4.00736 5.50736 3 6.75 3H14.3787C14.9754 3 15.5477 3.23705 15.9697 3.65901L18.841 6.53033C19.2629 6.95229 19.5 7.52458 19.5 8.12132V18.75C19.5 19.9926 18.4926 21 17.25 21H6.75C5.50736 21 4.5 19.9926 4.5 18.75V5.25Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3335 6.91667V4.25H14.8335V6.91667C14.8335 7.33088 15.1693 7.66667 15.5835 7.66667H18.2502V9.16667H15.5835C14.3409 9.16667 13.3335 8.15931 13.3335 6.91667Z",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08301 12.166C7.08301 11.7518 7.41879 11.416 7.83301 11.416L15.333 11.416C15.7472 11.416 16.083 11.7518 16.083 12.166C16.083 12.5802 15.7472 12.916 15.333 12.916L7.83301 12.916C7.41879 12.916 7.08301 12.5802 7.08301 12.166Z",
    fill: "#434343"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08301 8C7.08301 7.58579 7.41879 7.25 7.83301 7.25L11.1663 7.25C11.5806 7.25 11.9163 7.58579 11.9163 8C11.9163 8.41421 11.5806 8.75 11.1663 8.75L7.83301 8.75C7.41879 8.75 7.08301 8.41421 7.08301 8Z",
    fill: "#434343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08301 16.334C7.08301 15.9198 7.41879 15.584 7.83301 15.584L15.333 15.584C15.7472 15.584 16.083 15.9198 16.083 16.334C16.083 16.7482 15.7472 17.084 15.333 17.084L7.83301 17.084C7.41879 17.084 7.08301 16.7482 7.08301 16.334Z",
    fill: "#434343"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 6,
    r: 4,
    fill: "#883E89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIconDot);
export default __webpack_public_path__ + "static/media/documentIcon-dot.9e090b4044084bef7910e3dd3149a8ef.svg";
export { ForwardRef as ReactComponent };